<div class="testimonial-carousel-wrapper">
	<ngb-carousel
		#testimonialCarousel
		[showNavigationIndicators]="false"
		[showNavigationArrows]="false"
		[interval]="0"
		class="testimonial-carousel"
		(slide)="onTestimonialSlideChange($event)">
		@for (testimonial of testimonials; track testimonial) {
			<ng-template ngbSlide>
				<div class="testimonial-slide">
					<div class="row d-flex align-items-stretch">
						<div class="col-12 text-div" [ngClass]="hasVideo(testimonial) ? 'col-xl-4 with-video' : 'col only-text'">
							<div class="card">
								<div class="card-body">
									<div class="row controls-indicators d-flex align-items-center">
										<div class="col-auto">
											<button
												type="button"
												class="testimonial-carousel-btn testimonial-carousel-prev"
												(click)="goToPreviousSlide()"
												aria-label="Previous slide">
												<fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
											</button>
										</div>
										<div class="col-auto">
											<button
												type="button"
												class="testimonial-carousel-btn testimonial-carousel-next"
												(click)="goToNextSlide()"
												aria-label="Next slide">
												<fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
											</button>
										</div>
										<div class="col testimonial-counter">{{ currentTestimonialSlide + 1 }}/{{ totalTestimonialSlides }}</div>
									</div>
									<div class="row d-flex justify-content-end">
										<div class="col" [class.large-text]="!hasVideo(testimonial)">
											<span [innerHTML]="testimonial.content"></span>
										</div>
									</div>
									<div class="row d-flex align-items-center position-absolute bottom-0 mb-4">
										<div class="col-auto pe-2">
											@if (hasImage(testimonial)) {
												<img [src]="testimonial.image" [alt]="testimonial.name" class="headshot" />
											}
											@if (!hasImage(testimonial)) {
												<p class="headshot-initials mb-0">{{ testimonial.initials }}</p>
											}
										</div>
										<div class="col ps-2">
											<p class="partner-info">
												{{ testimonial.name }}<br />
												<span class="position-text">{{ testimonial.position }}</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						@if (hasVideo(testimonial)) {
							<div class="col-12 col-xl-8">
								<iframe
									[src]="getSafeVideoUrl(testimonial)"
									[title]="'Video testimonial from ' + testimonial.name"
									class="video-player"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									referrerpolicy="strict-origin-when-cross-origin"
									allowfullscreen></iframe>
							</div>
						}
					</div>
				</div>
			</ng-template>
		}
	</ngb-carousel>
</div>
